import { ClinicCanvasStage } from '../components/ClinicCanvasStage';
import { MagneticCta } from '../components/MagneticCta';
import { siteConfig } from '../../../shared/config/site';
import { scrollToSection } from '../../../shared/lib/scroll';

export function HeroSection() {
  const handleVisitClick = () => {
    scrollToSection('visit');
  };

  const handleCareClick = () => {
    scrollToSection('care');
  };

  return (
    <section
      id="hero"
      className="relative overflow-hidden pb-14 pt-6 sm:pt-8 lg:min-h-[calc(100svh-var(--demo-banner-height)-var(--header-height))] lg:pb-20 lg:pt-0"
    >
      <div className="mx-auto grid h-full max-w-[var(--container-max)] grid-cols-1 items-center gap-10 px-[var(--section-padding-x)] lg:min-h-[calc(100svh-var(--demo-banner-height)-var(--header-height))] lg:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)] lg:gap-14">
        <div className="max-w-xl lg:py-10">
          <h1 className="font-display tracking-tight text-ink">
            <span className="block text-[clamp(2.9rem,7.6vw,4.75rem)] font-bold leading-[0.9]">
              {siteConfig.shortName}
            </span>
            <span className="mt-3 block text-[clamp(1.25rem,2.9vw,1.85rem)] font-medium leading-tight text-primary-700">
              Veterinary Clinic
            </span>
          </h1>
          <p className="mt-6 max-w-[46ch] font-body text-[1.0625rem] leading-relaxed text-neutral-600 sm:text-lg">
            Calm exams, clear plans, and steady hands for companions across Bryanston and Sandton.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <MagneticCta href={siteConfig.phoneHref} variant="primary">
              Call {siteConfig.phoneDisplay}
            </MagneticCta>
            <MagneticCta href="#visit" onClick={handleVisitClick} variant="ghost">
              Plan your visit
            </MagneticCta>
          </div>
          <p className="mt-8 font-body text-sm text-neutral-600">
            <span className="font-display text-lg font-semibold text-ink">
              {siteConfig.ratingValue}
            </span>{' '}
            from{' '}
            <a
              href={siteConfig.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-neutral-300 underline-offset-4 transition hover:decoration-primary-600 hover:text-ink"
            >
              {siteConfig.reviewCount} Google reviews
            </a>
          </p>
        </div>

        <div className="relative lg:-mr-[max(0px,calc((100vw-var(--container-max))/2+var(--section-padding-x)))]">
          <div className="stage-frame relative aspect-[5/4] w-full overflow-hidden sm:aspect-[16/10] lg:aspect-auto lg:h-[min(64svh,32rem)] lg:rounded-l-3xl lg:rounded-r-none">
            <div className="stage-frame-inner" aria-hidden="true" />
            <ClinicCanvasStage hero pointerEnabled showLoader />
          </div>
          <button
            type="button"
            onClick={handleCareClick}
            className="mt-4 inline-flex min-h-[44px] items-center gap-2 rounded-lg px-1 font-body text-sm text-neutral-600 transition hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 lg:absolute lg:bottom-5 lg:left-6 lg:mt-0 lg:rounded-lg lg:bg-[rgba(11,18,20,0.72)] lg:px-3 lg:text-mist lg:backdrop-blur-sm lg:hover:text-white"
          >
            See how a visit works
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path
                d="M7 2v10M3 8.5L7 12.5l4-4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}
